import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import logo from '../assets/images/bugswork-light.svg';
import fb from '../assets/images/facebook.webp';
import ld from '../assets/images/linkedin.webp';
import ig from '../assets/images/instagram.webp';
import tw from '../assets/images/twiter.svg';
import yu from '../assets/images/youtube.svg';
import { Link } from 'gatsby';
import Button from 'react-bootstrap/Button';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import '../assets/scss/_common.scss';
import arrow from '../assets/images/right-arrow-white.svg';
import { reportConversion } from '../util/gtag';

function Footer({ pathname }: { pathname: string }) {
  const [isMobile, setIsMobile] = useState(false);
  const [isPad, setIsPad] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsPad(window.innerWidth >= 1170 && window.innerWidth <= 1230);
    };

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Initial call to set initial values
    handleResize();

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      className={`${isMobile ? 'footer-bckg accordian-img' : 'footer-bckg'}`}
    >
      <Container className="px-3 px-lg-0">
        <div className="d-flex flex-row justify-content-between pt-4 pt-lg-5">
          <div className={`col-lg-7 mb-3 mb-lg-0`}>
            <LazyLoadImage
              className="bugs-work-mobile-logo"
              effect="blur"
              src={logo}
              height={36}
              alt="Softobotics Logo"
            />
          </div>
          <div className={`col-5  col-lg-5 mb-3 mb-lg-0 p-0'}`}>
            <a target="_blank" href="https://www.youtube.com/@bugs-work">
              <LazyLoadImage
                className="fb-logo me-2 me-md-4 "
                src={yu}
                alt="facebook-logo-white"
              />
            </a>
            <a target="_blank" href="https://www.facebook.com/bugsdotwork/">
              <LazyLoadImage
                className="fb-logo me-2 me-md-4 "
                src={fb}
                alt="facebook-logo-white"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/bugs-work"
              target="_blank"
            >
              <LazyLoadImage
                className="fb-logo me-2 me-md-4 "
                effect="blur"
                src={ld}
                alt="LinkedIn Icon"
              />
            </a>
            <a href="https://x.com/BugsWork" target="_blank" className="">
              <LazyLoadImage
                className="fb-logo me-2 me-md-4  "
                effect="blur"
                src={tw}
                alt="Twitter Icon"
                width={22}
              />
            </a>
            <a href="https://www.instagram.com/bugswork/" target="_blank">
              <LazyLoadImage
                className="fb-logo ms-2 ms-md-4 "
                effect="blur"
                src={ig}
                alt="Instagram Icon"
              />
            </a>
          </div>
        </div>

        <div className="pt-4 pt-lg-5">
          <div className="d-flex flex-row justify-content-between align-items-start">
            <div className="col-7">
              <strong
                className="fnt-sm-14 footer-description fw-600"
                style={{ color: 'white' }}
              >
                Move fast, stay aligned,{' '}
              </strong>
              <br />
              <strong
                className="fnt-sm-14 footer-description fw-600"
                style={{ color: 'white' }}
              >
                and build better - together
              </strong>
              <div className="mt-3 mb-4 mb-lg-0">
                <Link
                  to={`${process.env.GATSBY_APP_URL}/registration/`}
                  target="_blank"
                >
                  <Button onClick={reportConversion} size="lg" className="font-14 fw-500 btn-contact-us">
                    Start for free{' '}
                    <img src={arrow} alt="arrow" className="ms-2" />
                  </Button>
                </Link>
                <div className="mt-2 text-white font-14 fw-400 no-credit-card-required">
                  *No credit card required
                </div>
              </div>

              <div className="col text-left d-md-none">
                <ul className="footer">
                  <li className="mb-2 text-white  text-hover fw-400 fnt-sm-14 fnt-16">
                    Contact Us
                  </li>
                  <li className="mb-2 text-white text-hover">
                    <a
                      href="tel:91-8147594806"
                      className="text-white   fw-400 fnt-sm-14 fnt-16"
                    >
                      +91-8147594806
                    </a>
                  </li>
                  <li className="mb-2  text-hover">
                    <a
                      href="mailto:contact@bugs.work"
                      className="text-white  fw-400 fnt-sm-14 fnt-16"
                    >
                      contact@bugs.work
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-5">
              <div className="row">
                <div className="col">
                  <ul className="footer">
                    <li className="mb-2 text-hover fw-400 fnt-sm-14 fnt-16">
                      <a
                        href={
                          pathname === '#testimonail'
                            ? '/#testimonial'
                            : '#testimonial'
                        }
                        className="text-white ms-2"
                      >
                        Why bugs.work
                      </a>
                    </li>
                    <li className="mb-2 text-hover fw-400 fnt-sm-14 font-16">
                      <Link
                        to="/resource/articles"
                        className={`text-white ms-2`}
                      >
                        Articles
                      </Link>
                    </li>
                    <li className="mb-2 text-hover fw-400 fnt-sm-14 fnt-16">
                      <Link to="/pricing" className="text-white ms-2">
                        Pricing
                      </Link>
                    </li>
                    <li className="mb-2 text-hover">
                      <a
                        href={pathname !== '' ? '/#faqs' : '#faqs'}
                        className="text-white ms-2  fw-400 fnt-sm-14 fnt-16 "
                      >
                        FAQs
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col text-left d-none d-md-block">
                  <ul className="footer">
                    <li className="mb-2 text-white ms-2 text-hover fw-400 fnt-16">
                      Contact Us
                    </li>
                    <li className="mb-2 text-white text-hover">
                      <a
                        href="tel:91-8147594806"
                        className="text-white ms-2  fw-400 fnt-16"
                      >
                        +91-8147594806
                      </a>
                    </li>
                    <li className="mb-2  text-hover">
                      <a
                        href="mailto:contact@bugs.work"
                        className="text-white ms-2 fw-400 fnt-16"
                      >
                        contact@bugs.work
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="mt-4 ms-2 d-none d-lg-block">
                <p className="me-1" style={{ color: 'white' }}>
                  Copyright © 2025
                  <a
                    className="mx-1 underline-text"
                    href="https://bugs.work/"
                    style={{ color: 'white' }}
                  >
                    bugs.work
                  </a>
                  | All Rights Reserved
                </p>
              </div>
              <div className="d-flex justify-content-sm-end justify-content-lg-start justify-content-md-start flex-wrap me-sm-4 me-md-2 me-lg-2">
                <p>
                  <Link
                    className="text-white mb-2 ms-sm-4  ms-lg-2 ms-md-2 fnt-sm-12 font-16"
                    to="/terms-of-use/"
                  >
                    Terms of Service
                  </Link>
                  .
                </p>
                <p>
                  <Link
                    className="text-white mb-2 ms-4 fnt-sm-12 font-16"
                    to="/privacy-policy/"
                  >
                    Privacy Policy
                  </Link>
                  .
                </p>

                <p>
                  <Link className="text-white mb-2 d-none" to="/cookie-policy/">
                    Cookie Policy
                  </Link>
                  .
                </p>
                <p>
                  <Link className="text-white mb-2 d-none" to="/GDPR/">
                    GDPR
                  </Link>
                  .
                </p>
                <p>
                  <Link
                    className="text-white mb-2 d-none"
                    to="/data-processing-agreement/"
                  >
                    Data Processing Agreement
                  </Link>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 fnt-sm-12 text-center d-lg-none">
          <p className="me-1" style={{ color: 'white' }}>
            Copyright © 2025
            <a
              className="mx-1 underline-text"
              href="https://bugs.work/"
              style={{ color: 'white' }}
            >
              bugs.work
            </a>
            | All Rights Reserved
          </p>
        </div>

        {/* <div className="d-flex justify-content-end flex-wrap me-4">
          <p>
            <Link
              className="text-white mb-2 ms-4 fnt-sm-12 font-16"
              to="/terms-of-use/"
            >
              Terms of Service
            </Link>
            .
          </p>
          <p>
            <Link
              className="text-white mb-2 ms-4 fnt-sm-12 font-16"
              to="/privacy-policy/"
            >
              Privacy Policy
            </Link>
            .
          </p>

          <p>
            <Link className="text-white mb-2 d-none" to="/cookie-policy/">
              Cookie Policy
            </Link>
            .
          </p>
          <p>
            <Link className="text-white mb-2 d-none" to="/GDPR/">
              GDPR
            </Link>
            .
          </p>
          <p>
            <Link
              className="text-white mb-2 d-none"
              to="/data-processing-agreement/"
            >
              Data Processing Agreement
            </Link>
            .
          </p>
        </div> */}
      </Container>
    </div>
  );
}

export default Footer;
